<template>
  <div class="color-picker-container">
    <v-flex>
      <v-btn
        :color="currentColor"
        @click="isShowing = !isShowing"
        class="ml-0"
      ></v-btn>
    </v-flex>
    <v-slide-y-transition>
      <v-flex v-if="isShowing">
        <span v-for="(color, index) in colors" :key="`${index}`">
          <input
            type="radio"
            name="color"
            :value="color"
            v-model="currentColor"
            @input="inputHandler"
            :id="color"
          />
          <label
            class="color-option"
            :for="color"
            :style="{ 'background-color': color }"
          >
          </label>
        </span>
      </v-flex>
    </v-slide-y-transition>
  </div>
</template>

<script>
import colors from "./colors.json";
export default {
  props: { value: String },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.currentColor = newVal;
      }
    }
  },
  data() {
    return {
      isShowing: false,
      currentColor: "",
      colors: colors
    };
  },
  methods: {
    inputHandler(event) {
      this.$emit("input", event.target.value);
    }
  }
};
</script>

<style scoped>
input {
  position: absolute;
  visibility: hidden;
  width: 0;
  height: 0;
}
input + label {
  cursor: pointer;
  transition: 1s;
}
input:checked + label {
  box-shadow: 4px 4px 8px 2px rgb(0, 0, 0, 0.5);
  transition: 1s;
}

.color-option {
  width: 50px;
  height: 20px;
  display: inline-block;
  margin: 2px;
}
.color-picker-container {
  margin-left: -2px;
  margin-right: -2px;
  line-height: 2px;
}
</style>
